import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

interface ActionButtonsProps {
  isActive: boolean;
  editRoute: string;
  onActivate: () => void;
  onDeactivate: () => void;
  onDeleteForever: () => void; // Add delete forever action
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  isActive,
  onActivate,
  onDeactivate,
  editRoute,
  onDeleteForever,
}) => {
  const navigate = useNavigate();

  const handleEditClick = () => {
    navigate(editRoute);
  };

  return (
    <div className="mt-auto">
      {isActive ? (
        <>
          <Button
            variant="primary"
            className="mt-2 me-2 w-35"
            onClick={handleEditClick}
          >
            Edit
          </Button>
          <Button
            variant="danger"
            className="mt-2 ms-2 w-35"
            onClick={onDeactivate}
          >
            Deactivate
          </Button>
        </>
      ) : (
        <>
          <Button
            variant="danger"
            className="mt-2 w-50"
            onClick={onDeleteForever}
          >
            Delete Forever
          </Button>
          <Button
            variant="success"
            className="mt-2 ms-2 w-35"
            onClick={onActivate}
          >
            Activate
          </Button>
        </>
      )}
    </div>
  );
};

export default ActionButtons;
